// extracted by mini-css-extract-plugin
module.exports = {"box":"quiz-game_box__XWecv","count":"quiz-game_count___i9cA","title":"quiz-game_title__1E1Qc"};